// extracted by mini-css-extract-plugin
module.exports = {"ConfirmPurchase":"ConfirmPurchase_ConfirmPurchase__X9u4I"};